export const formatFloat = (input) => {
  return Number(input).toFixed(2);
};

export const formatDate = (input) => {
  const d = new Date(input);

  const date = d.getDate();
  const month = d.getMonth() + 1;
  const year = d.getFullYear();

  return `${date}/${month}/${year}`;
};
